import React, { useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Sector,
  Legend,
} from "recharts"
import { truncateText } from "../../../../utils/functions"
import CustomTooltip from "./components/CustomTooltip"

const data = [
  {
    name: "Paquete de bienvenida",
    pv: 95,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Equipo",
    pv: 80,
    value: 9000,
  },
  {
    name: "Instalaciones de trabajo",
    pv: 95,
    value: 900,
  },
  {
    name: "Herramientas de trabajo",
    pv: 70,
    value: 900,
  },
  {
    name:
      "Equipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo aaaaaaaaa",
    pv: 90,
    value: 800,
  },
  {
    name: "Paquete de bienvenida",
    pv: 95,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Equipo",
    pv: 80,
    value: 9000,
  },
  {
    name: "Instalaciones de trabajo",
    pv: 95,
    value: 900,
  },
  {
    name: "Herramientas de trabajo",
    pv: 70,
    value: 900,
  },
  {
    name:
      "Equipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo aaaaaaaaa",
    pv: 90,
    value: 800,
  },
  {
    name: "Paquete de bienvenida",
    pv: 95,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Equipo",
    pv: 80,
    value: 9000,
  },
  {
    name: "Instalaciones de trabajo",
    pv: 95,
    value: 900,
  },
  {
    name: "Herramientas de trabajo",
    pv: 70,
    value: 900,
  },
  {
    name:
      "Equipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo aaaaaaaaa",
    pv: 90,
    value: 800,
  },
  {
    name: "Paquete de bienvenida",
    pv: 95,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Equipo",
    pv: 80,
    value: 9000,
  },
  {
    name: "Instalaciones de trabajo",
    pv: 95,
    value: 900,
  },
  {
    name: "Herramientas de trabajo",
    pv: 70,
    value: 900,
  },
]
let dataResult = []

const renderCustomLabel = (props) => {
  const RADIAN = Math.PI / 180
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props
  const sin = Math.sin(-RADIAN * midAngle)
  const cos = Math.cos(-RADIAN * midAngle)
  const sx = cx + (outerRadius + 10) * cos
  const sy = cy + (outerRadius + 10) * sin
  const mx = cx + (outerRadius + 30) * cos
  const my = cy + (outerRadius + 30) * sin
  const ex = mx + (cos >= 0 ? 1 : -1) * 22
  const ey = my
  const textAnchor = cos >= 0 ? "start" : "end"
  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        fontSize="12px"
        fontWeight="600"
        textAnchor={textAnchor}
        fill="#333">
        {payload.value_text}
      </text>
    </g>
  )
}

const COLORS = [
  "#2694FC",
  "#F6B673",
  "#55C8AE",
  "#E37879",
  "#E197D1",
  "#56CCF2",
  "#727DE2",
  "#C0D77E",
  "#EF9771",
  "#B173C7",
]

export function PieChartSingleAnswer(props) {
  const [activeIndex, setActiveIndex] = useState(null)

  if (props.data) {
    dataResult = []
    props.data.map((row) => {
      dataResult.push({
        name: row.answer_option_name,
        pv: Number(row.value),
        name_sort: truncateText(row.answer_option_name, 10),
        name_sort_legend: truncateText(row.answer_option_name, 90),
        value: Number(row.employees),
        value_text: row.value_text,
      })
    })
  }

  const onPieEnter = (_, index) => {
    setActiveIndex(index)
  }

  return (
    <div className="PieChartSingleAnswer">
      <ResponsiveContainer>
        <PieChart margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
          <Pie
            data={dataResult}
            innerRadius={60}
            outerRadius={90}
            fill="#8884d8"
            dataKey="value"
            activeIndex={activeIndex}
            onMouseEnter={onPieEnter}
            activeShape={(props) => renderCustomLabel(props)}>
            {data.map((_entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            content={(element) => (
              <CustomTooltip
                element={element}
                measureGeneral={props.measureGeneral}
              />
            )}
            cursor={{ fill: "transparent" }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

PieChartSingleAnswer.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureGeneral: PropTypes.object,
  getDataChildren: PropTypes.func,
  getBackData: PropTypes.func,
  dimensionParent: PropTypes.number,
  isAmbassador: PropTypes.bool,
  showDimensionBenchmark: PropTypes.bool,
  hideImpact: PropTypes.bool,
}
export default PieChartSingleAnswer
